import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Download from "../pages/download/page";
import ReportPage from "../pages/report/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download",
    element: <Download />,
  },
  {
    path: "/report",
    element: <ReportPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
